<template>
    <div>
        {{showText}}
    </div>
</template>

<script>
    import {mapGetters} from "vuex"
    export default {
        name: "order-status-text",
        props:['status','payst','dotimest'],
        data(){
            return {
                textMap : {
                    1 : '待提交',
                    2 : '待付款',
                    3 : '待鉴定',
                    4 : '鉴定完成',
                    5 : '订单已取消',
                    51 : '已过支付时间，订单已取消',
                    52 : '时间到期未鉴定，订单已取消',
                    6 : '资料待修正',
                    7 : '已评价',
                }
            }
        },
        computed : {
            ...mapGetters("jianding", ["CONST"]),
            showText(){
                let {textMap, status, payst, dotimest, CONST} = this;
                if(payst && status === CONST.ORDER_STATUS_CANCEL){
                    return textMap[51] || ""
                }
                if(dotimest && status === CONST.ORDER_STATUS_CANCEL){
                    return textMap[52] || ""
                }
                return textMap[this.status] || ""
            }
        }
    }
</script>

<style scoped>

</style>